import React from 'react';
import {connect} from 'react-redux';
import moment from 'moment';

import * as FavouriteState from 'constants/FavouriteState';

import {toggleMatch as toggleMatchAction} from 'actions/creators/ToggleMatch';
import {toggleGroup as toggleGroupAction} from 'actions/creators/ToggleGroup';
import {toggleFavouriteMatch as toggleFavouriteMatchAction} from 'actions/creators/Favourites';
import {requestFullLine as requestFullLineAction} from 'actions/creators/Line';

import {fetchStream as fetchStreamAction} from 'actions/creators/Stream';
import {setRadarWidget} from 'actions/widget/index.js';

import Body from './Body.jsx';
import MainLine from './MainLine.jsx';
import MatchScores from './matchStats/MatchScores.jsx';
import MatchTime from './matchStats/MatchTime.jsx';
import localeMap from 'constants/Locales'

const calendarConfig = {
    en: {
        sameDay: '[Today at] HH:mm',
        nextDay: '[Tomorrow at] HH:mm',
        lastWeek: 'D MMMM [at] HH:mm',
        nextWeek: 'D MMMM [at] HH:mm',
        sameElse: 'D MMMM [at] HH:mm'
    },
    ru: {
        sameDay: '[Сегодня в] HH:mm',
        nextDay: '[Завтра в] HH:mm',
        lastWeek: 'D MMMM [в] HH:mm',
        nextWeek: 'D MMMM [в] HH:mm',
        sameElse: 'D MMMM [в] HH:mm'
    },
    uz: {
        sameDay: '[Бугун соат] HH:mm',
        nextDay: '[Эртага соат] HH:mm',
        lastWeek: 'D MMMM HH:mm [да]',
        nextWeek: 'D MMMM HH:mm [да]',
        sameElse: 'D MMMM HH:mm [да]'
    },
}

class MatchHeader extends React.Component {
    static propTypes = {
        section: React.PropTypes.string.isRequired,
        languageId: React.PropTypes.number.isRequired,
        matchId: React.PropTypes.number,
        matchGroup: React.PropTypes.object,
        matchGroupId: React.PropTypes.number,
        matchGroupIsClosed: React.PropTypes.bool,
        match: React.PropTypes.object,
        isChoosenMatch: React.PropTypes.bool,
        gridLocalization: React.PropTypes.object.isRequired,
        showLineNumbers: React.PropTypes.bool.isRequired,
        toggleGroupAction: React.PropTypes.func.isRequired,
        toggleMatchAction: React.PropTypes.func.isRequired,
        toggleFavouriteMatchAction: React.PropTypes.func.isRequired,
        requestFullLineAction: React.PropTypes.func.isRequired,
        setRadarWidget: React.PropTypes.func.isRequired,
        gridSelection: React.PropTypes.object.isRequired,
        selectionToggleMatchAction: React.PropTypes.func.isRequired
    };

    constructor(props) {
        super(props);

        this._onExpandMatchClick = this._onExpandMatchClick.bind(this);
        this._onExpandBodyClick = this._onExpandBodyClick.bind(this);
        this._onFavouriteClick = this._onFavouriteClick.bind(this);
        this._onStreamClick = this._onStreamClick.bind(this);
    }

    componentWillMount() {
        const {section, gridLocalization, match, matchId, isChoosenMatch, gridSelection} = this.props;
        const inGridSelection = gridSelection.get('matchesExpanded').includes(matchId);

        if (isChoosenMatch || inGridSelection) {
            if (section === 'preMatch' && !match.get('isFullyLoaded')) {
                this.props.requestFullLineAction({
                    eventId: matchId,
                    languageId: gridLocalization.languageId
                });
            } else if (section === 'live' && !match.get('isClosed')) {
                this.props.toggleMatchAction({matchId, isClosed: !match.get('isClosed')}, section);
            }
        }
    }

    shouldComponentUpdate(nextProps) {
        return (
            this.props.match !== nextProps.match ||
            this.props.activeWidgetId !== nextProps.activeWidgetId ||
            this.props.matchGroupIsClosed !== nextProps.matchGroupIsClosed ||
            this.props.gridLocalization.languageId !== nextProps.gridLocalization.languageId ||
            this.props.showLineNumbers !== nextProps.showLineNumbers
        );
    }

    _onExpandMatchClick(e) {
        e.preventDefault();

        const {section, gridLocalization, matchId, match} = this.props;
        const isClosed = match.get('isClosed');

        this.props.selectionToggleMatchAction({id: matchId});

        if (section === 'preMatch' && !match.get('isFullyLoaded')) {
            this.props.requestFullLineAction({
                eventId: matchId,
                languageId: gridLocalization.languageId
            });

            return;
        }

        this.props.toggleMatchAction({matchId, isClosed: !isClosed}, section);
    }

    _onExpandBodyClick(e) {
        e.preventDefault();

        const {section, gridLocalization, match, matchId, matchGroupId} = this.props;
        const isClosed = match.get('isClosed');

        if (section === 'preMatch' && !match.get('isFullyLoaded')) {
            this.props.requestFullLineAction({
                eventId: matchId,
                languageId: gridLocalization.languageId
            });

            if (isClosed) {
                this.props.selectionToggleMatchAction({id: matchId});
            }

            return;
        }

        if (isClosed) {
            this.props.toggleMatchAction({matchId, isClosed: !isClosed}, section);
        }

        if (matchGroupId !== null) {
            this.props.toggleGroupAction(matchGroupId, section);
        }
    }

    _onFavouriteClick(e) {
        e.preventDefault();
        this.props.toggleFavouriteMatchAction(this.props.match);
    }

    renderMatchDate(date, languageId) {
        const timezone = moment.tz.guess();

        const locale = localeMap[languageId];
        moment.locale(locale);

        moment.updateLocale(locale, {
            calendar: calendarConfig[locale]
        });

        date.locale(locale).tz(timezone);

        return (
            <span className="match-header__date">
                {date.calendar()}
            </span>
        );
    }

    _onStreamClick() {
        const matchId = this.props.match.get('id');
        const channelStream = this.props.match.get('channel') || null;
        //const channelStream = "Матч! Футбол 1; url: http://172.28.3.150/hls/relay/MinCNUX/index.m3u8";

        if (channelStream !== null) {
            let src;
            const myRegexp = /url:(.*)/;
            const regexArray = myRegexp.exec(channelStream);

            if (regexArray) {
                src = regexArray[1].trim();
            }

            this.props.fetchStreamAction({matchId, src});
        }
    }

    render() {
        const {
            section,
            match,
            matchGroup,
            matchGroupId,
            matchGroupIsClosed,
            gridLocalization,
            showLineNumbers,
            activeWidgetId,
            languageId
        } = this.props;

        if (match === undefined) {
            return false;
        }

        const matchId = match.get('id');
        const radarId = match.get('radarId');
        const sportId = match.get('sportId');
        const notice = match.get('notice') || null;

        let name = match.get('name');
        if (notice !== null) {
            name = name + ' (' + notice + ')';
        }

        let tv = null;
        const channel = match.get('channel') || null;
        if (channel !== null) {
            tv = (<span className="tv" title={channel}>{' '}</span>);
        }

        const groupsExist = match.get('groups').size > 0;

        let favourite = null;
        if (section === 'live') {
            let favouritesCls = 'favourites';

            if (match.get('favouriteState') === FavouriteState.FULL) {
                favouritesCls += ' added';
            }

            favourite = (
                <a href="#" className={favouritesCls} onClick={this._onFavouriteClick}>
                    <span className="favourites__icon"/>
                </a>);
        }

        let matchGroupClass = 'event-name__link';
        const matchIsClosed = match.get('isClosed');
        const matchIsFullyLoaded = match.get('isFullyLoaded');
        const matchLineNumber = match.get('lineNumber');

        let renderBody = false;

        if (matchIsClosed === true || matchIsFullyLoaded === false) {
            matchGroupClass = 'event-name__link event-name__link--closed';
        } else {
            // const hasBody = matchGroup && matchGroup.get('outcomes').size > matchGroup.get('headers').size;
            const hasBody = matchGroup && matchGroup.get('hasBody');
            if (matchGroupId && hasBody) {
                matchGroupClass += matchGroupIsClosed ? ' event-name__link--closed' : ' event-name__link--expanded';

                renderBody = !matchGroupIsClosed;
            }
        }

        const groupProps = {
            section,
            gridLocalization
        };

        const scoresProps = {
            section,
            matchId,
            groupId: matchGroupId,
            gridLocalization
        };

        const mainLineProps = {
            id: matchGroupId,
            section,
            gridLocalization
        };

        const channelStream = match.get('channel') || null;
        const stream = (channelStream !== null && channelStream.includes('url:'));

        const isWidgetActive = radarId && activeWidgetId === radarId ? 'active' : '';

        return (
            <div className="event-header">
                <div className="controls">
                    {groupsExist &&
                    <a href="#" className="expand" onClick={this._onExpandMatchClick}>
                        <span>{'\u00A0'}</span>
                    </a>}
                    {favourite}
                </div>

                <div className="table">
                    <div className="row">
                        <span className="cell main">
                            <span className="event-name">
                                <a className={matchGroupClass} href="#" onClick={this._onExpandBodyClick} title={name}>
                                    <strong>{showLineNumbers && matchLineNumber}</strong> &nbsp; {name}
                                </a>

                                {radarId && <button onClick={() => this.props.setRadarWidget({radarId, name, sportId})} id={radarId} className={`radar-widget_btn ${isWidgetActive}`} />}
                            </span>
                            {section === 'preMatch' && this.renderMatchDate(match.get('startDate'), languageId)}
                            <span className="cell-main tools">
                                {section === 'preMatch' && tv}
                                {
                                    section === 'live' && <div>
                                        {(this.props.countryCode === 'KG' && stream) &&
                                        <button onClick={this._onStreamClick} className="play-stream_btn"></button>
                                        }
                                        <MatchScores {...scoresProps}/>
                                        <MatchTime id={match.get('id')} section={section}/>
                                    </div>
                                }
                            </span>
                        </span>
                        <MainLine {...mainLineProps} />
                    </div>
                </div>

                {matchGroupId && matchIsFullyLoaded && renderBody &&
                <Body key={matchGroupId} id={matchGroupId} {...groupProps} />}
            </div>
        );
    }
}

function select(state, props) {
    const {section, id, gridLocalization, isChoosenMatch, gridSelection, selectionToggleMatchAction} = props;

    const languageId = state.application.get('languageId');
    const activeWidgetId = state.application.get('betradar').activeWidgetId;
    const match = state.application.getIn([section, 'matches', id]);
    const showLineNumbers = state.application.hasIn([section, 'showLineNumbers']) ? state.application.getIn([section, 'showLineNumbers'], false) : false;

    let matchGroup;
    let matchGroupId;
    let matchGroupIsClosed = true;

    if (match !== undefined) {
        matchGroupId = match.get('matchGroup');

        if (matchGroupId !== undefined) {
            matchGroup = state.application.getIn([section, 'groups', matchGroupId]);

            if (matchGroup !== undefined) {
                matchGroupIsClosed = matchGroup.get('isClosed');
            }
        }
    }

    return {
        section,
        languageId,
        match,
        matchGroup,
        matchGroupId,
        matchGroupIsClosed,
        gridLocalization,
        showLineNumbers,
        isChoosenMatch,
        gridSelection,
        selectionToggleMatchAction,
        countryCode: state.application.get('countryCode'),
        user: state.auth.get('user'),
        activeWidgetId,
    };
}

export default connect(select, {
    fetchStreamAction, toggleGroupAction, toggleMatchAction, toggleFavouriteMatchAction, requestFullLineAction, setRadarWidget
})(MatchHeader);



// WEBPACK FOOTER //
// ./js/sport-betting/components/grid-control/components/MatchHeader.jsx